<!--
 @description 作业平台
 @author xiehan
 @date 2018/10/23
-->
<template>
  <div class="platform platform__content">
    <el-button
      type="primary"
      @click="addPlatform"
      v-g-rac="gRac('platform@addPlatform')" 
      v-text="$t('platform.addPlatform')"></el-button>
    <el-button 
      type="primary" 
      class="ml-base" 
      @click="checkHistory"
      v-g-rac="gRac('platform@checkHistory')" 
      v-text="$t('platform.checkHistory')"></el-button>
    <div class="mt-base">
      <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="0" input-width="auto">
        <el-form-item prop="toolName">
          <el-input v-model="searchForm.toolName" :placeholder="$t('platform.toolName')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
            v-g-rac="gRac('platform@search')"
            @click="search"
            v-text="$t('common.search')"></el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <div class="split-line"></div>
      <div class="each-command mr-large"
        v-for="item in select_command"
        v-text="item"
        :key="item"
        @click="chooseCommand(item)"
        :class="{ 'choosen-active' : choosenText === item }"></div>
    </div>
    <div>
      <div v-for="(item, index) in toolList" class="each-tool" :key="'key' + index" @click="chooseTool(item)">
        <img :src="toolImg">
        <div v-text="item.fileName"></div>
      </div>
      <div v-show="toolList.length === 0" v-text="$t('common.noData')" class="no-data"></div>
    </div>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import platformBiz from '@/logic/continuousDelivery/platformBiz'
  export default {
    mixins: [rac, dic],
    data () {
      return {
        searchForm: {
          toolName: ''
        },
        select_command: {},
        choosenText: '',
        oldToolList: [],
        toolList: [],
        toolImg: require('@/assets/image/tool.png')
      }
    },
    methods: {
      addPlatform () {
        this.$router.push({ name: 'handlerPlatform' })
      },
      checkHistory () {
        this.$router.push({ name: 'platformHistory' })
      },
      search () {
        let text = this.searchForm.toolName
        this.toolList = this.oldToolList.filter((item) => {
          return item.fileName.indexOf(text) !== -1
        })
      },
      async waitCommand (fromRouter = false) {
        await this.dGetDictionaryByCode('commandType')
        this.select_command = { ...this.dDictionary.commandType }
        if (fromRouter) {
          this.chooseCommand(this.select_command['3'], fromRouter)
        } else {
          this.chooseCommand(this.select_command['3'])
        }
      },
      chooseCommand (i, fromRouter = false) {
        for (let j in this.select_command) {
          if (this.select_command[j] === i && (fromRouter || this.choosenText !== i)) {
            platformBiz.getPlatforms({ type: j }).then((d) => {
              this.$refs.searchForm.resetFields()
              this.oldToolList = d.dataList
              this.toolList = d.dataList
              this.choosenText = i
            })
          }
        }
      },
      chooseTool (i) {
        this.$router.push({ name: 'handlerPlatform', query: { id: i.id } })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'platform' && from.name === 'handlerPlatform') {
          this.waitCommand(true)
        }
      }
    },
    mounted () {
      this.waitCommand()
    }
  }
</script>

<style scoped>
  .platform {
    font-size: 14px;
  }
  .each-command {
    display: inline-block;
    cursor: pointer;
    color: #a9a9a9;
  }
  .each-command:hover {
    color: #3385ff;
  }
  .split-line {
    width: 800px;
    height: 20px;
    text-align: center;
    color: #000;
    line-height: 20px;
    position: relative;
  }
  .split-line:after {
    content: "";
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 50%;
    z-index: 1;
    background: #ddd;
    left: 0;
  }
  .choosen-active {
    color: #3385ff;
  }
  .each-tool {
    width: auto;
    display: inline-block;
    text-align: center;
    padding: 10px;
    cursor: pointer;
  }
  .each-tool:hover img {
    position: relative;
    top: -1px;
    left: -1px;
  }
  .no-data {
    text-align: center;
    margin-top: 20px;
  }
</style>